import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import {replace} from 'lodash';
import Icon from '../../Icon';
import {injectIntl} from 'react-intl';
import {requestSurveyList} from '../../../actions/action_survey_list';
import {requestDetailSurvey} from '../../../actions/action_detail_survey';
import TypeIcon from './TypeIcon';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {constants} from '@neosvoc/nv-platform-core-common';

const stripTags = (input) => replace(input, /<[^>]*>/g, '');

const sliceText = (str, maxLength) => {
    if (str.length <= maxLength) {
        return str;
    }
    const subString = str.substr(0, maxLength-1);
    const lastSpace = subString.lastIndexOf(' ');
    return `${subString.substr(0, lastSpace)}...`;
};

/* eslint-disable react/jsx-no-bind */
class ItemCopyFromPicker extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.openSurvey = this.openSurvey.bind(this);
        this.closeSurvey = this.closeSurvey.bind(this);
        this.checkPage = this.checkPage.bind(this);
        this.uncheckPage = this.uncheckPage.bind(this);
        this.copy = this.copy.bind(this);

        this.state = {
            open: false,
            selected: {},
            order: [],
        };
    }

    componentDidMount() {
        this.loadSurveyList();
    }

    componentDidUpdate(prevProps, prevState) {
        // if detail is updated, we are receiving pages for a specific survey
        if (prevProps.detail !== this.props.detail) {
            const selected = this.state.selected;
            const order = this.state.order;
            selected[this.props.detail.id].items = this.props.detail.editor.pages;
            this.setState((prevState) => ({
                open: prevState.open,
                selected,
                order,
            }));
        }
    }

    openSurvey(surveyId) {
        const selected = this.state.selected;
        if (!selected[surveyId]) {
            selected[surveyId] = {open: false, checked: [], items: []};
        }
        selected[surveyId].open = true;
        const order = this.state.order;
        this.setState((prevState) => ({
            open: prevState.open,
            selected,
            order,
        }));
        if (!this.state.selected[surveyId] || this.state.selected[surveyId].items.length === 0) {
            this.props.requestDetailSurvey(surveyId);
        }
    }

    closeSurvey(surveyId) {
        const selected = this.state.selected;
        const order = this.state.order;
        selected[surveyId].open = false;
        this.setState((prevState) => ({
            open: prevState.open,
            selected,
            order,
        }));
    }

    checkPage(surveyId, pageId) {
        const selected = this.state.selected;
        const order = this.state.order;
        selected[surveyId].checked.push(pageId);
        order.push({surveyId, pageId});
        this.setState((prevState) => ({
            open: prevState.open,
            selected,
            order,
        }));
    }

    uncheckPage(surveyId, pageId) {
        const selected = this.state.selected;
        let order = this.state.order;
        selected[surveyId].checked = selected[surveyId].checked.filter((item) => item != pageId);
        order = order.filter((item) => item.surveyId != surveyId || (item.surveyId === surveyId && item.pageId !== pageId));
        this.setState((prevState) => ({
            open: prevState.open,
            selected,
            order,
        }));
    }

    loadSurveyList() {
        this.props.requestSurveyList(0, 9999);
        // this.props.requestSurveyList((this.props.page - 1) * PAGE_SIZE, PAGE_SIZE); TODO: add pagination?
    }

    toggle() {
        this.setState((prevState) => ({
            open: !prevState.open,
            selected: prevState.selected,
            order: prevState.order,
        }));
    }

    copy() {
        const check = Object.values(this.state.selected).some((item) => item.checked && item.checked.length > 0);
        if (!check) {
            return;
        }

        const result = [];

        for (const entry of this.state.order) {
            const {surveyId, pageId} = entry;
            const items = this.state.selected[surveyId].items;

            let filteredItems = items.filter((page) => page.id === pageId);
            filteredItems = filteredItems.map((page) => {
                const pageWithDefaults = {...page, postScripts: [], preScripts: [], terminal: false};
                pageWithDefaults.items = (page.items || []).map((item) => {
                    if (item.type === constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2) {
                        return {...item, choices: (item.choices || []).map((c) => ({...c, choiceScripts: []}))};
                    }
                    return item;
                });
                return pageWithDefaults;
            });
            console.log(filteredItems);
            result.push(...filteredItems);
        }

        this.setState({open: false, selected: {}, order: []});
        this.props.onItemClicked(result);
    }

    render() {
        const {items} = this.props;

        return (
            <Fragment>
                <Button onClick={this.toggle} className="survey-editor-item copy-item full-width mb20">
                    <FontAwesomeIcon icon={['far', 'copy']} fixedWidth={true} className="icon" />
                    <FormattedMessage {...messages.surveys.button.copy_editor} />
                </Button>
                <Modal isOpen={this.state.open} toggle={this.toggle} size="lg">
                    <ModalHeader toggle={this.toggle}>
                        <FormattedMessage {...messages.surveys.modals.copyQuestion.title} />
                    </ModalHeader>
                    <ModalBody>
                        <div style={{overflow: 'auto', height: '50vh'}}>
                            {items.length > 0 && items.map((item) =>
                                <div key={'survey_' + item.id}>
                                    {this.state.selected[item.id] && this.state.selected[item.id].open === true ? (
                                        <Icon icon="minus" onClick={() => this.closeSurvey(item.id)} />
                                    ) : (
                                        <Icon icon="plus" onClick={() => this.openSurvey(item.id)} />
                                    )}
                                    {item.name}

                                    {this.state.selected[item.id] && this.state.selected[item.id].checked.length > 0 &&
                                    <span style={{fontStyle: 'italic'}}>
                                        &nbsp;(<FormattedMessage {...messages.surveys.modals.copyQuestion.selected} />
                                        &nbsp;{this.state.selected[item.id].checked.length})
                                    </span>
                                    }
                                    {this.state.selected[item.id] && this.state.selected[item.id].open && (
                                        <div>
                                            {this.state.selected[item.id].items.length === 0 && (
                                                <div style={{marginLeft: '24px'}}>
                                                    <i>(<FormattedMessage {...messages.surveys.modals.copyQuestion.noQuestions} />)</i>
                                                </div>
                                            )}
                                            {this.state.selected[item.id].items.map((page) =>
                                                <div key={'survey_' + item.id + '_' + page.id} style={{marginLeft: '24px'}}>
                                                    {this.state.selected[item.id].checked.includes(page.id) ? (
                                                        <Icon icon="check_checked" onClick={() => this.uncheckPage(item.id, page.id)} />
                                                    ) : (
                                                        <Icon icon="check_empty" onClick={() => this.checkPage(item.id, page.id)} />
                                                    )}
                                                    <TypeIcon type={page.items[0].type} item={page.items[0]} />
                                                    <b>{page.id}</b>&nbsp;
                                                    <span title={page.items[0].title ? stripTags(page.items[0].title) : stripTags(page.items[0].text)}>
                                                        {page.items[0].title ?
                                                            sliceText(stripTags(page.items[0].title), 148) : sliceText(stripTags(page.items[0].text), 148)}
                                                    </span>
                                                </div>,
                                            )}
                                        </div>
                                    )}
                                </div>,
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className={classNames('btn btn-outline-secondary btn-sm')} onClick={this.toggle}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary" onClick={this.copy}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        items: state.surveyList.items,
        detail: state.surveyDetail.item,
    };
};

export default injectIntl(connect(mapStateToProps, {requestSurveyList, requestDetailSurvey})(ItemCopyFromPicker));
